import ApolloClient, { createNetworkInterface } from 'apollo-client';

import {GRAPHQL_URL, AUTH0_ID_TOKEN_NAME} from './consts';

const graphqlUrl = `https://${GRAPHQL_URL}`;

const {localStorage} = window;

const networkInterface = createNetworkInterface({
  uri: graphqlUrl,
  opts: {}
});

networkInterface.use([{
  applyMiddleware(req, next) {
    if (!req.options.headers) {
      req.options.headers = {};  // Create the header object if needed.
    }

    //temporary will change this token
    const authToken = localStorage.getItem(AUTH0_ID_TOKEN_NAME);

    if (authToken) {
      req.options.headers.Authorization = `Bearer ${authToken}`;
    }

    next();
  }
}]);

const client = new ApolloClient({
  networkInterface,
  initialState: {},
  queryDeduplication: false
});

export default client;



// WEBPACK FOOTER //
// ./src/apollo.js